import { RootState } from '../store';

export const getNotifications = (state: RootState) => state.notifications.items;
export const getNotificationsLoaded = (state: RootState) => state.notifications.loaded;
export const getUnseenNotificationsCount = (state: RootState) =>
  state.notifications.items.reduce((acc, n) => acc + (n.readAt ? 0 : 1), 0);
